import React from 'react';

import * as Styles from './ColorWheelIcon.styles';

export const RAINBOW_IMAGE_URL =
  'https://material-ui-widgets.s3.us-west-2.amazonaws.com/color-wheel.png';

interface Props {
  onClick?: () => void;
  wrapperClassName?: string;
  size?: number;
}

const ColorWheelIcon: React.FC<Props> = ({
  wrapperClassName,
  size = 1,
  onClick,
}) => {
  return (
    <Styles.Icon onClick={onClick} fontSize={size} className={wrapperClassName}>
      <img alt="colorwheel" src={RAINBOW_IMAGE_URL} />
    </Styles.Icon>
  );
};

export default ColorWheelIcon;
